module.exports = __webpack_public_path__ + "img/首图背景@1.5x.785938d7.png";